import React, { useState } from 'react';
import '@/App.less';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom"

import { checkLogin, checkCurrentUser } from "@/utils"

import LoginPage from "@/pages/login"
import IndexPage from "@/pages"
import TestPage from "@/pages/test"
import UserIndexPage from "@/pages/users"
import CollectionSitesPage from "@/pages/collectionSites"
import SellingSitesPage from "@/pages/sellingSites"
import SellingSiteDevicesPage from "@/pages/sellingSites/devices"
import SellingSiteTagsPage from "@/pages/sellingSites/tags"
import PublicComponentPackagesPage from "@/pages/publicComponents/packages"
import PublicComponentPackageComponentsPage from "@/pages/publicComponents/packageComponents"
import PublicComponentGroupsPage from "@/pages/publicComponents/groups"
import PublicComponentGroupComponentsPage from '@/pages/publicComponents/groupComponents'

function Default404Page() {
  return (
    <h1>This is 404 Page</h1>
  )
}

function AppRoute({ children, needLogin, ...rest }) {

  const [memoLogin, setMemoLogin] = useState(null)

  const isLogin = checkLogin()

  // 检测本地登录状态是否变化
  if (isLogin !== memoLogin) {

    checkCurrentUser().then((currentUser) => {

      const _login = currentUser !== null

      setMemoLogin(_login)
    })

    return null
  }

  const renderProps = (props) => {
    if (needLogin && !memoLogin) {
      const { location } = props
      return <Redirect to={{ pathname: "/login", state: { from: location } }} />
    }

    return children
  }

  return <Route {...rest} render={renderProps} />
}

function App() {
  return (
    <Router basename="/admin">
      <Switch>
        <AppRoute exact needLogin path="/">
          <IndexPage />
        </AppRoute>
        <AppRoute exact needLogin path="/users">
          <UserIndexPage />
        </AppRoute>
        <AppRoute exact needLogin path="/collectionSites">
          <CollectionSitesPage />
        </AppRoute>
        <AppRoute exact needLogin path="/sellingSites">
          <SellingSitesPage />
        </AppRoute>
        <AppRoute exact needLogin path="/sellingSites/devices">
          <SellingSiteDevicesPage />
        </AppRoute>
        <AppRoute exact needLogin path="/sellingSites/tags">
          <SellingSiteTagsPage />
        </AppRoute>

        <AppRoute exact needLogin path="/publicComponents/packages">
          <PublicComponentPackagesPage />
        </AppRoute>
        
        <AppRoute exact needLogin path="/publicComponents/packageComponents">
          <PublicComponentPackageComponentsPage />
        </AppRoute>

        <AppRoute exact needLogin path="/publicComponents/groups">
          <PublicComponentGroupsPage />
        </AppRoute>

        <AppRoute exact needLogin path="/publicComponents/groupComponents">
          <PublicComponentGroupComponentsPage />
        </AppRoute>

        <AppRoute exact needLogin path="/test">
          <TestPage />
        </AppRoute>
        <AppRoute exact path="/login">
          <LoginPage />
        </AppRoute>
        <AppRoute path="*">
          <Default404Page />
        </AppRoute>
      </Switch>
    </Router>
  );
}



export default App;
